<template>
<div class="main">
  <div class="header">
    <img src="@/assets/images/manticore.png">
  </div>

  <h1>Off Market Entry</h1>

  <div class="form-section">

    <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="500">
      <div class="addressarea ut-mb-2" v-if="!maddress">
        <label class="cuslabel maddress">Address</label>

        <AddressSearch v-if="showab" :existingAddress="existingAddress" :gacategory="gacategory" :disabled="disableAddressInput" :placeholderText="'Enter your property address'" class="addressSearchBox" @selectedResult="getAddress" :showIcon="true"></AddressSearch>

      </div>

    </transition>

    <input type="checkbox" v-model="maddress" id="maddress"></input>
    <label for="maddress">Enter address manually</label>

    <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in" :duration="500">
      <div class="maddressarea" v-if="maddress">

        <InputField class="inf" :id="'f0'" :type="'text'" v-bind:value="formData.streetAddress" v-on:input="formData.streetAddress = $event" :disabled="false">Street Address</InputField>

        <SuburbSearch :placeholderText="'Enter your suburb or postcode'" class="suburbsearch" :existingAddress="existingSuburb" @selectedResult="getSuburb" :showIcon="true"></SuburbSearch>

      </div>
    </transition>

    <div class="errrormsg embox" v-if="!checkAddress && submitted">Please enter address details</div>

    <h3 class="rblabel">Property Type</h3>

    <div class="rb">
      <RadioButton v-for="btn in propertyTypes" :key="btn.id" :id="btn.id" :name="'Example Question'" v-model="formData.propertyTypeId" :selectedValue="formData.propertyTypeId" :radioValue="btn.value">
        {{btn.label}}</RadioButton>
    </div>

    <div class="errrormsg" v-if="!checkPropertytype && submitted">Please select a property type</div>

    <div class="inf-3">

      <div class="box">
        <InputField class="inf" :id="'f4'" :type="'number'" v-bind:value="formData.beds" v-on:input="formData.beds = $event" :disabled="false">Bed</InputField>
        <div class="errrormsg embox" v-if="!checkBed && submitted">Please fill in bed</div>
      </div>

      <div class="box">
        <InputField class="inf" :id="'f5'" :type="'number'" v-bind:value="formData.baths" v-on:input="formData.baths = $event" :disabled="false">Bath</InputField>
        <div class="errrormsg embox" v-if="!checkBath && submitted">Please fill in bath</div>
      </div>

      <div class="box">
        <InputField class="inf" :id="'f6'" :type="'number'" v-bind:value="formData.cars" v-on:input="formData.cars = $event" :disabled="false">Car</InputField>
        <div class="errrormsg embox" v-if="!checkCar && submitted">Please fill in car</div>
      </div>

    </div>


    <div class="inf-5">

      <div class="box">
        <InputField class="inf" :id="'f8'" :type="'number'" v-bind:value="formData.priceGuideType.priceRangeFrom" v-on:input="formData.priceGuideType.priceRangeFrom = $event" :disabled="false">Asking Price</InputField>
        <div class="errrormsg embox" v-if="!checkAskingprice && submitted">Please fill asking price</div>
      </div>

      <div class="box">
        <InputField class="inf" :id="'f7'" :type="'number'" v-bind:value="formData.landsize" v-on:input="formData.landsize = $event" :disabled="false">Land size</InputField>
      </div>


    </div>

    <h3 class="rblabel">Ideal time frame</h3>

    <div class="rb">
      <RadioButton v-for="btn in expecttosell" :key="btn.id" :id="btn.id" :name="'Example Question'" v-model="formData.expecttosell" :selectedValue="formData.expecttosell" :radioValue="btn.value">
        {{btn.label}}</RadioButton>
    </div>

    <div class="errrormsg" v-if="!checkTimeframe && submitted">Please select a time frame</div>

    <h3 class="rblabel">Intent level</h3>

    <div class="rb">
      <RadioButton v-for="btn in intent" :key="btn.id" :id="btn.id" :name="'Example Question'" v-model="formData.listingAuthors[0].intent" :selectedValue="formData.listingAuthors[0].intent" :radioValue="btn.value">
        {{btn.label}}</RadioButton>
    </div>

    <label class="cuslabel" for="description">Description</label>
    <textarea v-bind:class="{valid: checkDesc}" v-model="formData.description" name="description" rows="4"></textarea>

    <label class="cuslabel" for="notes">Notes</label>
    <textarea v-bind:class="{valid: checkNotes }" v-model="formData.notes[0].note" name="notes" rows="4"></textarea>

    <LoadingSpinner class="loading" v-if="loading"></LoadingSpinner>

    <div class="btnbox" v-if="!loading" @click="sendFormData()">
      <Button class="btn">Send</Button>
    </div>

  </div>

  <NotificationModal :status="nmodalStatus" :msg="nmodalMsg" :name="'NotificationModal'"></NotificationModal>

</div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/forms/Button.vue';
import InputField from '@/components/forms/InputField.vue';
import RadioButton from '@/components/forms/RadioButton.vue';
import AddressSearch from '@/components/forms/search/AddressSearch.vue';
import SuburbSearch from '@/components/forms/search/SuburbSearch.vue';
import NotificationModal from '@/components/modals/notification.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import qs from 'qs';

export default {
  name: 'Home',
  components: {
    Button,
    InputField,
    RadioButton,
    AddressSearch,
    SuburbSearch,
    NotificationModal,
    LoadingSpinner,
  },
  data() {
    return {
      oaUserKey: null,
      loading: false,
      showab: false,
      submitted: false,
      validate: {
        address: false,
        propertyType: false,
        expecttosell: false,
        intent: false,
        description: false,
        notes: false,
      },
      propertyTypes: [{
          id: 'property-house',
          value: 1,
          label: 'House',
        },
        {
          id: 'property-apartment',
          value: 2,
          label: 'Apartment',
        },
        {
          id: 'property-land',
          value: 3,
          label: 'Land',
        },
      ],
      intent: [{
          id: 'intent-medium',
          value: 50,
          label: 'Medium',
        },
        {
          id: 'intent-high',
          value: 100,
          label: 'High',
        },
      ],
      expecttosell: [{
          id: 'expecttosell-1',
          value: 'Immediately',
          label: 'Now',
        },
        {
          id: 'expecttosell-2',
          value: '3 - 6 months',
          label: '3 - 6 mth',
        },
        {
          id: 'expecttosell-3',
          value: '6 - 12 months',
          label: '6 - 12 mth',
        },
        {
          id: 'expecttosell-4',
          value: 'I don’t know / > 12months',
          label: '12 mth +',
        },
      ],
      gacategory: "offmarket-entry",
      disableAddressInput: false,
      maddress: false,
      existingAddress: '',
      existingSuburb: '',
      updateLead: false,
      leadKey: '',
      nmodalStatus: '',
      nmodalMsg: '',
      userData: {
        fullName: '',
        firstName: '',
        lastName: '',
        email: '',
        mobilePhone: '',
        otherPhone: '',
      },
      formData: {
        oaLeadId: '',
        streetAddress: '',
        beds: '',
        baths: '',
        cars: '',
        landsize: '',
        description: '',
        propertyTypeId: '',
        oaPropertyAddressId: '',
        expecttosell: '',
        propertyListingStatusTypeId: 1,
        propertyListingTypeId: 1,
        oaUserId: '',
        postCode: {
          id: '',
          suburb: '',
          postcode: '',
          state: '',
        },
        priceGuideType: {
          id: 2,
          priceRangeFrom: null,
        },
        notes: [{
          noteTypeId: 1,
          note: '',
        }],
        listingAuthors: [{
          userKey: '',
          isPassiveSeller: 1,
          intent: '50',
          listingTypeId: 2,
          sellerMotivationTypeId: 1,
        }],
      },
      addressData: {
        rpdataid: '',
        streetaddress: '',
        suburb: '',
        state: '',
        postcode: '',
        postcodeid: '',
        latitude: '',
        longitude: '',
      },
    };
  },
  computed: {
    checkNotes: function() {
      if (this.formData.notes[0].note !== '') {
        return true;
      } else {
        return false;
      }
    },
    checkDesc: function() {
      if (this.formData.description !== '' || this.submitted) {
        return true;
      } else {
        return false;
      }
    },
    checkTimeframe: function() {
      if (this.formData.expecttosell !== '') {
        return true;
      } else {
        return false;
      }
    },
    checkAskingprice: function() {
      if (this.formData.priceGuideType.priceRangeFrom !== '') {
        return true;
      } else {
        return false;
      }
    },
    checkPropertytype: function() {
      if (this.formData.propertyTypeId !== '') {
        return true;
      } else {
        return false;
      }
    },
    checkBed: function() {
      if (this.formData.beds !== '' || this.formData.propertyTypeId == 3) {
        return true;
      } else {
        return false;
      }
    },
    checkBath: function() {
      if (this.formData.baths !== '' || this.formData.propertyTypeId == 3) {
        return true;
      } else {
        return false;
      }
    },
    checkCar: function() {
      if (this.formData.cars !== '' || this.formData.propertyTypeId == 3) {
        return true;
      } else {
        return false;
      }
    },
    checkAddress: function() {
      if (this.formData.streetAddress !== '' && this.formData.postCode.postcode !== '') {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    nmodal(status, message) {
      this.nmodalMsg = message;
      this.nmodalStatus = status;
      this.loading = false;
      this.$modal.show('NotificationModal');
    },
    getSuburb(selected) {
      console.log(selected);
      this.formData.postCode.suburb = selected.suburb;
      this.formData.postCode.postcode = selected.postcode;
      this.formData.postCode.state = selected.state;
      this.formData.postCode.id = selected.id;

      this.addressData.latitude = selected.latitude;
      this.addressData.longitude = selected.longitude;

      this.addressData.streetaddress = this.formData.streetAddress;
      this.addressData.state = this.formData.postCode.state;
      this.addressData.suburb = this.formData.postCode.suburb;
      this.addressData.postcode = this.formData.postCode.postcode;
      this.addressData.postcodeid = this.formData.postCode.id;

      this.updateLead = true;

    },
    getAddress(selected) {
      console.log(selected);
      this.formData.streetAddress = selected.details.streetaddress;
      this.formData.postCode.suburb = selected.details.suburb;
      this.formData.postCode.postcode = selected.details.postcode;
      this.formData.postCode.state = selected.details.state;

      this.addressData.rpdataid = selected.details.id;
      this.addressData.latitude = selected.details.latitude;
      this.addressData.longitude = selected.details.longitude;

      axios.get(`${process.env.VUE_APP_API_URL}/postcoderest/find/${selected.details.suburb}`).then((res) => {
          this.formData.postCode.id = res.data.data[0].id;

          this.addressData.streetaddress = this.formData.streetAddress;
          this.addressData.state = this.formData.postCode.state;
          this.addressData.suburb = this.formData.postCode.suburb;
          this.addressData.postcode = this.formData.postCode.postcode;
          this.addressData.postcodeid = this.formData.postCode.id;

          this.updateLead = true;

        })
        .catch((e) => {
          console.log(e);
        });
    },
    getCookie(name) {
      let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      if (match) return match[2];
    },
    createMKTListing() {
      axios.post(`${process.env.VUE_APP_MKTAPI_URL}/v1/user`, this.userData, {
          headers: {
            'Authorization': 'Basic FB1CB115-178B-4CD9-A9CC-C58336E10699',
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          console.log(response);

          if (!response.data.success) {
            this.nmodal('Oh no', response.data.message);
            return;
          }

          this.formData.listingAuthors[0].userKey = response.data.data.key;

          console.log(this.formData);

          axios.post(`${process.env.VUE_APP_MKTAPI_URL}/v1/property-listing`, this.formData, {
              headers: {
                'Authorization': 'Basic FB1CB115-178B-4CD9-A9CC-C58336E10699',
                'Content-Type': 'application/json',
              },
            }).then((response) => {
              console.log(response);
              if (response.data.success) {

                let stageData = {
                  leadstagetypeid: 22,
                  oauserkey: this.oaUserKey,
                  platformtypeid: 1,
                };

                axios.put(`${process.env.VUE_APP_API_URL}/leadrest/update-lead-stage/${this.leadKey}`, qs.stringify(stageData)).then((res) => {
                    console.log(res);

                    if (res.data.success) {
                      this.nmodal('Success', response.data.message);
                    } else {
                      this.nmodal('Oh no', response.data.message);
                    }

                  })
                  .catch((e) => {
                    console.log(e);
                    this.nmodal('Oh no', e.data.message);
                  });
              } else {
                this.nmodal('Oh no', response.data.message);
              }
            })
            .catch((e) => {
              console.error(e);
              this.nmodal('Oh no', e.data.message);
            })

        })
        .catch((e) => {
          console.error(e);
          this.nmodal('Oh no', e.data.message);
        })
    },
    validateForm() {
      let isFormValid = true;

      if (!this.checkTimeframe || !this.checkAskingprice || !this.checkPropertytype || !this.checkBed || !this.checkBath || !this.checkCar) {
        isFormValid = false;
      }

      return isFormValid;
    },
    sendFormData() {

      if (this.formData.notes[0].note.trim() == '') {
        this.formData.notes[0].note = 'n/a';
      }

      let validForm = this.validateForm();

      this.submitted = true;

      if (validForm) {
        this.loading = true;

        if (this.formData.baths == '') {
          this.formData.baths = 0;
        }
        if (this.formData.beds == '') {
          this.formData.beds = 0;
        }
        if (this.formData.cars == '') {
          this.formData.cars = 0;
        }

        this.formData.priceGuideType.priceRangeFrom = Number(this.formData.priceGuideType.priceRangeFrom);

        if (this.updateLead) {

          this.addressData.streetaddress = this.formData.streetAddress;

          axios.put(`${process.env.VUE_APP_API_URL}/leadrest/update-lead/${this.leadKey}`, qs.stringify(this.addressData)).then((res) => {
              console.log(res);
              this.formData.oaPropertyAddressId = res.data.data.propertyaddressid;
              this.createMKTListing();
            })
            .catch((e) => {
              console.log(e);
            });

        } else {
          this.createMKTListing();
        }
      }

    },
  },
  created() {

    let user = this.getCookie('user');

    this.formData.oaLeadId = (this.$route.query.leadId ? this.$route.query.leadId : '');

    if (!user || !this.formData.oaLeadId) {
      window.location.href = `${process.env.VUE_APP_PHEONIX}`;
    } else {
      let usercookie = $cookies.get('user');
      this.formData.oaUserId = usercookie.userId;
      this.oaUserKey =  usercookie.key;
    }

    axios.get(`${process.env.VUE_APP_API_URL}/leadrest/lead-by-id/${this.formData.oaLeadId}`).then((res) => {
        console.log(res);

        this.leadKey = res.data.data.key;
        this.formData.streetAddress = (res.data.data.streetaddress ? res.data.data.streetaddress : '');
        this.formData.postCode.state = (res.data.data.state ? res.data.data.state : '');
        this.formData.postCode.suburb = (res.data.data.suburb ? res.data.data.suburb : '');
        this.formData.postCode.postcode = (res.data.data.postcode ? res.data.data.postcode : '');
        this.formData.beds = (res.data.data.beds ? res.data.data.beds : '');
        this.formData.postCode.id = (res.data.data.postcodeid ? res.data.data.postcodeid : '');
        this.formData.oaPropertyAddressId = (res.data.data.propertyaddressid ? res.data.data.propertyaddressid : '');
        this.formData.priceGuideType.priceRangeFrom = (res.data.data.expectedsalepricelow ? res.data.data.expectedsalepricelow : '');

        this.formData.priceGuideType.priceRangeFrom = this.formData.priceGuideType.priceRangeFrom.substring(0, this.formData.priceGuideType.priceRangeFrom.indexOf('.'));

        this.userData.fullName = `${res.data.data.firstname} ${res.data.data.lastname}`;
        this.userData.firstName = res.data.data.firstname;
        this.userData.lastName = res.data.data.lastname;
        this.userData.email = res.data.data.email;
        this.userData.mobilePhone = res.data.data.phone;
        this.userData.otherPhone = res.data.data.phoneother;

        this.existingSuburb = `${this.formData.postCode.suburb}, ${this.formData.postCode.state} ${this.formData.postCode.postcode}`;

        this.existingAddress = `${this.formData.streetAddress}, ${this.formData.postCode.suburb} ${this.formData.postCode.state} ${this.formData.postCode.postcode}`;

        if (res.data.data.propertytype.toLowerCase() == 'house') {
          this.formData.propertyTypeId = 1;
        }

        if (res.data.data.propertytype.toLowerCase() == 'apartment' || res.data.data.propertytype.toLowerCase() == 'unit') {
          this.formData.propertyTypeId = 2;
        }

        if (res.data.data.propertytype.toLowerCase() == 'land') {
          this.formData.propertyTypeId = 3;
        }

        this.showab = true;
      })
      .catch((e) => {
        console.log(e);
      });

  },
};
</script>

<style scoped lang="scss">
.main {
    padding-bottom: 100px;
    min-width: 500px;

    .header {
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        height: 50px;
        width: 100%;
        img {
            left: 90%;
            top: 19px;
            transform: translateX(-90%);
            position: absolute;
        }
    }

    h1 {
        text-align: center;
        font-size: 32px;
        font-weight: 400;
        line-height: 40px;
        margin: 40px 0;
    }

    .form-section {
        padding: 10px 24px 30px;
        background-color: #fff;
        width: 450px;
        margin: 0 auto;
        border-radius: 3px;
        box-shadow: -1px 12px 20px 0 rgba(164,158,158,0.5);

        .btnbox {
            width: fit-content;
            margin: 0 auto;
            .btn {
                width: 200px;
                margin: 50px auto 0;
            }
        }

        .rblabel {
            margin-bottom: 0;
        }

        .rb {
            display: flex;
            flex-wrap: wrap;
        }

        .inf {
            margin: 20px 0;
        }

        .inf-5 {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            .box {
                width: 48%;
            }
            .inf {
                margin: 0;
                width: 100%;
            }
        }

        .inf-3 {
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            .box {
                width: 31%;
            }
            .inf {
                margin: 0;
                width: 100%;
            }
        }
        .cuslabel {
            display: block;
            margin: 15px 0 10px;
        }
        .errrormsg {
            color: #F83C5B;
            &.embox {
                margin-top: 8px;
            }
        }
    }
}
</style>
